import { CoupleFileResponse } from '@/api/Files/types';

export const getCouplePseudoId = (couple: CoupleFileResponse) =>
  `${couple[0]._id}_${couple[1]._id}`;
